import script from "./ClientsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsTable.vue?vue&type=script&setup=true&lang=js"

import "./ClientsTable.vue?vue&type=style&index=0&id=e2e87290&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2e87290"]])

export default __exports__